<template>
  <div id="app">
    <h1>
     <span style="color:red">Will hayes</span> cloudflare pages
    </h1>
    <h2 v-for="(k,index) of list" :key="index">{{k}}</h2>
    <div class="line">

    </div>
    <pre>
      {{ssr}}
    </pre>
  </div>
</template>

<script>

export default {
  name: 'App',
  data(){
    return {
      list:[],
      ssr:null
    };
  },
  components: {
  },
 async created(){
   if(process.env.NODE_ENV==='development'){
     this.list.push(...['local_will','local_penny'])
   }else{
     this.list.push(...(await (await fetch('/list')).json()))
   }
   await this.getSsr();
  },
  methods: {
  async  getSsr(){
      // let ssrData = await (await fetch('https://yitian.life/code/query?xhr=2')).json();
      // this.ssr=JSON.stringify(ssrData,null,2);
    }
  },

}
</script>

<style>
*{
  margin: 0;
  padding: 0;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

.line{
  width:100%;
  height: 15px;
  background-color: gray;
}
</style>
